module.exports = __webpack_public_path__ + "static/media/eukonline_service_kit.fbc3bbe2.png";